import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import LZString from "~/ts/library/LZString";

export default class Cobrowse extends AbstractOperatorApplicationListener {
    cobrowseCallback: (action: string, changes: any, pageId: string) => void;
    siteId: string;
    clientId: string;

    constructor(userdata: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, callback: (action: string, changes: any, pageId: string) => void) {
        super();
        this.siteId = userdata.siteId;
        this.clientId = userdata.clientId;
        this.cobrowseCallback = callback;
    }

    getAction(): string {
        return "browser";
    }

    protected receive(payload: any): void {
        let data = payload.data;
        if (typeof data == "object") {
            if (data.siteID == this.siteId && data.talkID == this.clientId) {
                if (data.hasOwnProperty("action") && data.hasOwnProperty("changes")) {
                    try {
                        let changes = LZString.decompressFromBase64(data.changes);
                        changes = JSON.parse(changes);
                        this.cobrowseCallback(data.action, changes, data.pageID);
                    } catch (e) {
                        console.error("cobrowse error", e);
                        console.trace();
                    }
                }
            }
        }
    }

}